import FormattedMessage from 'I18n/components/FormattedMessage';
import { isNotFoundError } from 'personalization-lib/utils/error';
import { jsx as _jsx } from "react/jsx-runtime";
const SegmentError = ({
  error
}) => {
  if (isNotFoundError(error)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.targeting.errors.notFound"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "personalizationLib.targeting.errors.default"
  });
};
export default SegmentError;